import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataService } from '../../../services/data/data.service';
import { IPaymentFlow } from '../../../interfaces/IPayments';
import { PAYMENT_FLOW_CANCEL_PLAN } from '../../../utils/constants';
import { UtilitiesService } from '../../../services/utilities/utilities.service';
import { CINCH_CONTACT_NUMBER_AMOUNT_DUE } from '../../../services/ga4/ga4.constant';

@Component({
  selector: 'app-payment-disclaimers-and-terms-and-conditions',
  templateUrl: './payment-disclaimers-and-terms-and-conditions.component.html',
  styleUrl: './payment-disclaimers-and-terms-and-conditions.component.scss'
})
export class PaymentDisclaimersAndTermsAndConditionsComponent implements OnInit {
  @Input() paymentOptionsForm!: FormGroup;
  @Input() onTermsAndConditions: () => void = () => {};
  paymentInitiation: IPaymentFlow | null = null;
  cancelPlanFlow = PAYMENT_FLOW_CANCEL_PLAN;
  contactNumber: string = '';
  contactPhoneBtnName = CINCH_CONTACT_NUMBER_AMOUNT_DUE;

  constructor(private data: DataService, private util: UtilitiesService) { }

  ngOnInit(): void {
    this.paymentInitiation = this.data.paymentInitiation$.getValue();
    this.contactNumber = this.util.getContactNumber(this.data.contractData$.getValue()?.baseContract!);
  }
}
